import { Component, Host, Prop, h } from "@stencil/core";

@Component({
    tag: "ux-iws-teaser-selectable-download",
    styleUrl: "teaser-selectable-download.scss",
})
export class TeaserSelectableDownload {
    private baseClass = "ux-iws-teaser-selectable-download";

    /** marks if the compoent should be preselected, therefore not showing the checkbox element */
    @Prop() preselected = false;

    render() {
        return (
            <Host
                class={{
                    [this.baseClass]: true,
                    [`${this.baseClass}--preselected`]: this.preselected,
                }}
            >
                <div class={`${this.baseClass}__image-container`}>
                    <slot />
                </div>
                <div class={`${this.baseClass}__text-container`}>
                    <div class={`${this.baseClass}__info-container`}>
                        <div class={`${this.baseClass}__checkbox-container`}>
                            <slot name="checkbox" />
                        </div>
                        <slot name="file-info" />
                    </div>
                    <slot name="text" />
                </div>
            </Host>
        );
    }
}
